import { getParam } from "@/shared/helpers/url-helper";

/*
 * The checkout token for the current gift card order, used to join webview events to the app's
 * `Gift Card Order - Checkout Create - Succeeded` event and to checkout's `transactionToken`.
 * The app injects it into its checkout webview; on the web it comes back on the portal redirect
 * as `orderToken`. Analytics only, so it never throws.
 */
export const getGiftCardCheckoutToken = (): string | undefined => {
    try {
        if (typeof window === "undefined") return undefined;

        return window.apAppParamToken || getParam("orderToken", window.location.href) || undefined;
    } catch {
        return undefined;
    }
};
